{
  "email": "Correo",
  "emailAddress": "Dirección de correo",
  "emailAddressPlaceholder": "Introduce tu dirección de correo",
  "continue": "Continuar",
  "send": "Enviar",
  "resend": "Reenviar",
  "sendCodeErrorTip": "Error al enviar el código: {error}",
  "sendEmailTips": "Hemos enviado un código de verificación a tu correo",
  "verificationCode": "Código de verificación",
  "codePlaceholder": "Introduce el código",
  "wallet": "Cartera",
  "otherLoginMethods": "Otros métodos de inicio de sesión",
  "login": "Iniciar sesión",
  "user": "Usuario",
  "loginTitle": "Iniciar sesión / Registrarse",
  "loginTips": "Puedes usar los siguientes métodos",
  "passwordMinError": "La contraseña debe tener al menos {length} caracteres",
  "passwordMatchError": "Las contraseñas no coinciden",
  "passwordTitle": "Establecer contraseña",
  "passwordTips": "Configura la contraseña para recuperar tu cartera",
  "password": "Contraseña",
  "passwordPlaceholder": "Introduce tu contraseña",
  "rePassword": "Confirmar contraseña",
  "rePasswordPlaceholder": "Repite la contraseña",
  "recoverTitle": "Recuperar cartera",
  "recoverTips": "Introduce tu contraseña para recuperar la cartera",
  "bindWith": "Vincular con la cartera {name}",
  "loginWith": "Iniciar sesión con la cartera {name}",
  "editUsernameTitle": "Editar nombre de usuario",
  "setUsernameTitle": "Establecer nombre de usuario",
  "username": "Nombre de usuario",
  "usernamePlaceholder": "Introduce tu nombre de usuario",
  "usernameValidError": "El nombre puede contener letras, números y caracteres",
  "usernameLengthError": "El nombre debe tener al menos 2 caracteres",
  "confirm": "Confirmar",
  "nextTime": "La próxima vez",
  "setUsername": "Establecer nombre de usuario",
  "disconnect": "Desconectar",
  "CEXBindTitle": "Vincular API de {type}",
  "CEXBindAttention": "Atención:",
  "CEXBindTips1": "1. Por favor, vincula la API con permisos de solo lectura.",
  "CEXBindTips2": "2. Tu API puede estar desactualizada, es mejor usar una API a largo plazo.",
  "CEXBindTips3": "3. Solo se puede vincular una API al mismo intercambio a la vez.",
  "CEXBindApiKey": "Clave API",
  "CEXBindApiSecretKey": "Clave Secreta API",
  "CEXBindApiPassphrase": "Frase de contraseña API",
  "cancel": "Cancelar",
  "walletLoading": "El servicio de cartera se está cargando",
  "tokenDetails": "Detalles del Token",
  "tokenAmountMin": "La cantidad debe ser mayor que 0.",
  "tokenAmountMax": "Saldo insuficiente.",
  "tokenAddressError": "Dirección no válida.",
  "amount": "Cantidad",
  "amountPlaceholder": "Ingrese la cantidad.",
  "balance": "Saldo",
  "receiveTitle": "Dirección de billetera recibida",
  "receivePlaceholder": "Ingrese la dirección de la billetera recibida.",
  "next": "Siguiente",
  "copied": "Copiado",
  "receiveQrcode": "Recibir escaneando el código QR",
  "copyAddress": "Copiar dirección",
  "tokenSmartContract": "Contrato inteligente del Token",
  "tokenSmartContractPlaceholder": "Ingrese el contrato inteligente del Token.",
  "tokenSymbol": "Símbolo del Token",
  "tokenSymbolPlaceholder": "Ingrese el símbolo del Token.",
  "tokenDecimals": "Decimales",
  "tokenDecimalsPlaceholder": "Ingrese los decimales.",
  "import": "Importar",
  "receive": "Recibir",
  "customizedToken": "Token personalizado",
  "noMoreRecords": "¡No hay más registros aquí!",
  "noRecords": "¡No hay registros aquí!",
  "close": "Cerrar",
  "back": "Atrás",
  "importSuccess": "Token importado con éxito",
  "importFail": "Error al importar el token",
  "changeNetwork": "Cambiar red",
  "approveSuccess": "Autorizado con éxito",
  "Approve": "Autorizar",
  "noFriends": "Aún no hay amigos",
  "noRequests": "Aún no hay solicitudes",
  "noMore": "No hay más",
  "Remove": "Eliminar",
  "removeSuccess": "Eliminado con éxito"

}
